import { useEffect } from 'react';
import { usePrivacyStore } from '@lib/store';
import { cn } from '@shared/utils';
import { PageLayout } from '@shared/widgets';
import TermIcon from '@assets/images/terms_ico.svg';
import styles from './info.module.css';

export const PrivacyPolicyPage = () => {
  const privacyStore = usePrivacyStore();

  useEffect(() => {
    privacyStore.get();
  }, []);

  return (
    <PageLayout>
      <div className='mx-auto w-[1440px] max-md:w-auto'>
        <TermIcon className='mx-auto mt-4 mb-12 hidden max-md:block' />
        <div className='mt-[90px] mb-7.5 flex items-center max-md:m-0 max-md:mb-4'>
          <div className='h-[1px] w-[140px] bg-[#272727] max-md:hidden' />
          <h2 className='ml-6 font-[Prata] text-[56px] text-[#272727] max-md:relative max-md:mx-auto max-md:text-[28px]'>Privacy Policy</h2>
        </div>
        <div className='mt-[50px] mb-[176px] flex justify-between max-md:m-0 max-md:px-4'>
          <div
            dangerouslySetInnerHTML={{ __html: privacyStore.data }}
            className={cn('mx-[164px] columns-2 gap-x-[10%] max-md:m-0 max-md:columns-1', styles.content)}
          />
        </div>
      </div>
    </PageLayout>
  );
};
